import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import './ParkTicketConfigurator.css'
import Captcha from '../../../components/Captcha'
import {NavLink} from 'react-router-dom'
import {Element, scroller} from 'react-scroll'
import DatePickerFormComponent from '../../../components/redux-form/DatePickerFormComponent'
import moment from 'moment'
import VehicleSelectFormComponent from '../../../components/redux-form/VehicleSelectFormComponent'

class ParkTicketConfigurator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedParkTicketType: null,
      selectedMark: null,
      selectedStartDate: null,
      selectedVehicle: null,
      selectedVehicleType: null
    }
    this.checkUserMark = this.checkUserMark.bind(this)
    this.getUserMark = this.getUserMark.bind(this)
    this.onParkTicketTypeSelected = this.onParkTicketTypeSelected.bind(this)
    this.onStartDateChange = this.onStartDateChange.bind(this)
    this.onVehicleSelected = this.onVehicleSelected.bind(this)
    this.onVehicleTypeChange = this.onVehicleTypeChange.bind(this)
  }

  checkUserMark (markTypeId) {
    if (!markTypeId) {
      return true
    }

    for (let index in this.props.user.marks) {
      let mark = this.props.user.marks[index]
      if (mark.markTypeId === markTypeId) {
        return true
      }
    }

    return false
  }

  getUserMark (markTypeId) {
    if (!markTypeId) {
      return null
    }

    for (let index in this.props.user.marks) {
      let mark = this.props.user.marks[index]
      if (mark.markTypeId === markTypeId) {
        return mark
      }
    }

    return null
  }

  getParkTicketLabel (parkTicketTypeName) {
    switch (parkTicketTypeName) {
      case 'monthly_standard':
        return 'STANDARD MENSILE'
      case 'weekly_standard':
        return 'STANDARD SETTIMANALE'
      case 'monthly_facilitated_bs':
        return 'AGEVOLATO BS MENSILE'
      case 'monthly_facilitated_bp':
        return 'AGEVOLATO BP MENSILE'
    }
  }

  onParkTicketTypeSelected (parkTicket) {
    let obj = {selectedParkTicketType: parkTicket}
    if (parkTicket.MarkTypeId) {
      obj.selectedMark = this.getUserMark(parkTicket.MarkTypeId)
    } else {
      obj.selectedMark = null
    }

    this.setState(obj, () => {
      scroller.scrollTo('step-two', {
        duration: 1000,
        delay: 100,
        smooth: true
      })
    })
  }

  onStartDateChange (date) {
    this.setState({selectedStartDate: date}, () => {
      scroller.scrollTo('step-three', {
        duration: 1000,
        delay: 100,
        smooth: true
      })
    })
  }

  onVehicleSelected (value) {
    this.setState({selectedVehicle: value}, () => {
      if (value.id) {
        scroller.scrollTo('step-final', {
          duration: 1000,
          delay: 100,
          smooth: true
        })
      }
    })
  }

  onVehicleTypeChange (event) {
    this.setState({selectedVehicleType: event.target.value}, () => {
      scroller.scrollTo('step-final', {
        duration: 1000,
        delay: 100,
        smooth: true
      })
    })
  }

  render () {
    return (
      <form onSubmit={this.props.handleSubmit(values => {
        this.props.onSubmit({...values, parkTicketType: this.state.selectedParkTicketType, mark: this.state.selectedMark})
      })}>
        <div className="col-md-8 col-md-push-2">
          <div className="panel panel-default panel-border">
            <div className="panel-body">
              <NavLink to="/user-area" className="btn btn-green btn-lg-back">Torna indietro</NavLink>
              <h2 className="title title-special">Acquista Abbonamento</h2>
              <p>Da qui puoi acquistare un nuovo abbonamento per la sosta nel Comune di Empoli.<br /></p>

              <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <legend className="text-left">1) Tipologia Abbonamento</legend>
                    <p>Seleziona il tipo di abbonamento che intendi acquistare</p>
                  </div>

                  <div className="row">
                    {this.props.parkTicketTypes.map((item, i) => {
                      if (!this.checkUserMark(item.MarkTypeId)) {
                        return null
                      }

                      const mark = this.getUserMark(item.MarkTypeId)

                      let activeClass = ''
                      if (this.state.selectedParkTicketType) {
                        if (this.state.selectedParkTicketType.id === item.id) {
                          activeClass = ' active'
                        }
                      }

                      return (<div key={i} className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <div onClick={() => this.onParkTicketTypeSelected(item)} className={'panel panel-default park-ticket-panel panel-border' + activeClass}>
                          <div className="panel-body text-center">
                            <h4>{this.getParkTicketLabel(item.name)}</h4>
                            <h3 className="title3">€ {Number(item.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
                            <div className="panel-body flex-grow panel-2">
                              {mark && <span style={{fontSize: '1.4rem'}}>Associato al tuo <strong>Contrassegno {mark.MarkType.name}</strong> num.: <strong>{mark.id}</strong><br /></span>}
                              Valido <strong>{
                              item.monthly
                                ? '1 mese'
                                : item.halfYearly
                                  ? '6 mesi'
                                  : item.daily
                                    ? '1 giorno'
                                    : '1 settimana'
                            }</strong>
                              {!item.MarkType && <span>nelle zone: <strong>S1 S2</strong>.</span>}
                              {item.MarkType && <span>nell{item.MarkType.Areas.length > 1 ? 'e' : 'a'} zon{item.MarkType.Areas.length > 1 ? 'e' : 'a'}: {item.MarkType.Areas.map((areaItem, index) => <span key={index}><strong>{areaItem.code}</strong>{(index < item.MarkType.Areas.length - 1) ? ', ' : ''}</span>)}.</span>}
                            </div>
                          </div>
                        </div>
                      </div>)
                    })}

                    <Field name="parkTicketType" component="input" type="hidden" />

                  </div>
                </fieldset>
              </div>

              {this.state.selectedParkTicketType && <div className="box" style={{marginBottom: '5rem'}}>
                <fiedset>
                  <div id="park-ticket-create-step-two" className="titolo-categoria">
                    <Element name="step-two" />
                    <legend className="text-left">2) Data Validit&agrave;</legend>
                  </div>
                  <div className="row">
                    <p>Seleziona la data di inizio validità dell'abbonamento</p>
                    <div className=" col-md-offset-2 col-md-4 text-left">
                      <label>Data Inizio Validit&agrave;</label>
                      <Field onDateChange={this.onStartDateChange} placeholderText="GG/MM/AAAA" component={DatePickerFormComponent} minDate={moment()} name="startDate" className="resident-login" required />
                    </div>
                    {this.state.selectedStartDate && <div className="col-md-4 text-left">
                      <label>Data Fine Validit&agrave;</label>
                      <div style={{marginTop: 12}}>
                        <h4>{this.state.selectedParkTicketType.monthly ? moment(this.state.selectedStartDate).add(29, 'days').format('L') : moment(this.state.selectedStartDate).add(6, 'days').format('L')}</h4>
                      </div>
                    </div>}
                  </div>
                </fiedset>
              </div>}
              {(this.state.selectedParkTicketType && this.state.selectedStartDate) && <div className="box">
                <fiedset>
                  <div className="titolo-categoria">
                    <Element name="step-three" />
                    <legend className="text-left">3) Informazioni Veicolo</legend>
                  </div>
                  {this.state.selectedMark && <div className="row">
                    <div className="col-md-12">
                      <p>Questo abbonamento &egrave; utilizzabile con i veicoli abilitati nel tuo contrassegno</p>
                    </div>
                    {this.state.selectedMark.Vehicles.map((item, index) => {
                      return (<div key={index}>
                        <div className="col-md-offset-2 col-md-4 text-left">
                          <label>Targa</label>
                          <div style={{marginTop: 12}}>
                            <h4>{item.plate_number}</h4>
                          </div>
                        </div>

                        <div className="col-md-4 text-left">
                          <label>Tipologia di Propriet&agrave;</label>
                          <div style={{marginTop: 12}}>
                            <h4>{item.type}</h4>
                          </div>
                        </div>
                      </div>)
                    })}
                  </div>}
                  {!this.state.selectedMark && <div className="row">
                    <div className="col-md-offset-2 col-md-4 text-left">
                      <label>Targa C</label>
                      <Field component={VehicleSelectFormComponent}
                             onValueChange={this.onVehicleSelected}
                             vehicles={this.props.user.vehicles}
                             required
                             name={'vehicle'}
                             newveicle={true}
                             className="resident-login" />
                    </div>
                    {(this.state.selectedVehicle && !this.state.selectedVehicle.id) && <div className="col-md-4 text-left">
                      <label>Tipologia di proprietà</label>
                      <Field onChange={this.onVehicleTypeChange} required name={'vehicleType'} component="select" className="form-control sel1-control">
                        <option value={''}>Seleziona tipo di proprietà</option>
                        {this.props.vehicleTypes.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)}
                      </Field>
                    </div>}

                    {(this.state.selectedVehicle && this.state.selectedVehicle.id) && <div className="col-md-4 text-left">
                      <label>Tipologia di propriet&agrave;</label>
                      <div style={{marginTop: 12}}>
                        <h4>{this.state.selectedVehicle.type}</h4>
                      </div>
                    </div>}
                  </div>}
                </fiedset>

              </div>}

              {(
                this.state.selectedParkTicketType &&
                this.state.selectedStartDate &&
                (
                  (this.state.selectedVehicle && this.state.selectedVehicle.id && !this.state.selectedMark) ||
                  (this.state.selectedVehicle && !this.state.selectedVehicle.id && this.state.selectedVehicleType && !this.state.selectedMark) ||
                  this.state.selectedMark
                )
              ) && <div className="box">
                <fieldset>
                  <div className="titolo-categoria">
                    <Element name="step-final" />
                    <legend className="text-left">Riepilogo</legend>
                  </div>

                  <div className="col-md-6">
                    <div className="card-marks">
                      <div className="caption" style={{padding: 10}}>
                        {this.state.selectedParkTicketType.printLabel && <h5>
                          <strong>
                            {this.state.selectedParkTicketType.printLabel && this.state.selectedParkTicketType.printLabel} {this.state.selectedMark && this.state.selectedMark.Category.label.toUpperCase()}
                          </strong>
                        </h5>}
                        {!this.state.selectedParkTicketType.printLabel && <h5>
                          <strong>
                            STANDARD
                          </strong>
                        </h5>}
                        <h5>
                          {this.state.selectedParkTicketType.MarkTypeId && <span>
                            <strong>zon{this.state.selectedMark.MarkType.Areas.length > 1 ? 'e' : 'a'}:</strong> {this.state.selectedMark.MarkType.Areas.map(item => item.code + ' ')}
                            </span>}
                          {this.state.selectedParkTicketType.name.indexOf('standard') > 0 && <span><strong>Valido nelle zone:</strong> S1 S2</span>}
                        </h5>
                        {this.state.selectedMark && <h5><strong>Num. Contrassegno:</strong> {this.state.selectedMark.id}</h5>}
                        {this.state.selectedMark && <h5><strong>Targ{this.state.selectedMark.Vehicles.length > 0 ? 'he' : 'a'}: {this.state.selectedMark.Vehicles.map(item => item.plate_number + ' ')}</strong></h5>}
                        {!this.state.selectedMark && <h5><strong>Targa: {this.state.selectedVehicle.plate_number.toUpperCase()}</strong></h5>}
                        <h5><strong>Valido dal </strong> {moment(this.state.selectedStartDate).format('L')} <strong>al</strong> {this.state.selectedParkTicketType.monthly ? moment(this.state.selectedStartDate).add(29, 'days').format('L') : moment(this.state.selectedStartDate).add(6, 'days').format('L')}</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h3>Totale: € {Number(this.state.selectedParkTicketType.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
                  </div>
                </fieldset>

                <fiedset>
                  <div className="row">
                    <div className="col-md-4 col-md-offset-4" style={{marginTop: 10}}>
                      {this.props.loadingCreation && <span className="text-danger">Aggiunta in corso...</span>}
                      {this.props.formErrors && <span className="text-danger">{JSON.stringify(this.props.formErrors)}</span>}
                    </div>
                  </div>
                </fiedset>
                <p>
                  <button type="submit" className="btn btn-green btn-lg-back">
                    Aggiungi al Carrello
                  </button>
                </p>
              </div>}
            </div>
          </div>
        </div>
      </form>)
  }
}

export default reduxForm({
  form: 'parkTicketConfigurator',
  enableReinitialize: true
})(ParkTicketConfigurator)



// WEBPACK FOOTER //
// ./src/containers/UserArea/ParkTicket/ParkTicketConfigurator.js